import { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { GetRecommendedUpNextQuery, GetRecommendedUpNextQueryVariables } from '@/types/codegen-federation'
import { isDefined } from '@/utils/types'
import { getWebClient } from '../ApolloClient'
import { GET_RECOMMENDED_UP_NEXT } from './queries'
import { RecommendedUpNextResult } from './types'

export const useGetRecommendedUpNext = (projectSlug: string): RecommendedUpNextResult => {
  const client = getWebClient()
  const { data, loading } = useQuery<GetRecommendedUpNextQuery, GetRecommendedUpNextQueryVariables>(
    GET_RECOMMENDED_UP_NEXT,
    {
      client,
      variables: { projectSlug },
      errorPolicy: 'all',
    },
  )

  return useMemo(() => {
    const recommendedUpNext = data?.recommendedUpNextV2?.content?.filter(isDefined) ?? []

    return { recommendedUpNext, loading }
  }, [data, loading])
}
